import React, { createContext, useContext, useEffect, useState } from "react";

export const dict = {
  it: {
    nav: {
      home: "Home",
      services: "Servizi",
      territory: "Territorio",
      booking: "Prenota",
      contact: "Contatti",
      book_now: "Prenota Ora",
    },
    hero: {
      eyebrow: "Autista Privato — Gallura, Sardegna",
      title: "Il tuo autista privato in Costa Smeralda",
      subtitle:
        "Transfer di lusso e tour personalizzati a bordo della nostra Chrysler 300C Touring blu. Eleganza americana, ospitalità sarda.",
      cta_primary: "Prenota la corsa",
      cta_secondary: "Scopri i servizi",
      kpi_1: "Anni di esperienza",
      kpi_2: "Tour Gallura",
      kpi_3: "Comfort a bordo",
    },
    car: {
      eyebrow: "L'auto",
      title: "Chrysler 300C Touring — Blu Notte",
      desc: "Una berlina station wagon americana iconica. Interni in pelle, climatizzazione automatica, ampio bagagliaio per le vostre valigie e bottiglie d'acqua sempre a bordo.",
      f1: "Fino a 4 passeggeri",
      f2: "Bagagli grandi",
      f3: "Wi-Fi a bordo",
      f4: "Acqua omaggio",
      gallery_title: "Galleria",
      gallery_hint: "Passa sopra le foto per la descrizione",
      more_photos_title: "Vuoi vedere altre foto dell'auto?",
      more_photos_hint: "Scrivici su WhatsApp: te le inviamo subito (interni, bagagliaio, dettagli)",
    },
    services: {
      eyebrow: "Servizi",
      title: "Transfer & Tour su misura",
      lead: "Tariffe trasparenti, pagamento a bordo (contanti o carta), autista in giacca e cravatta.",
      from: "da",
      duration: "Durata",
      min: "min",
      book: "Prenota",
    },
    territory: {
      eyebrow: "Il territorio",
      title: "Esplora la Gallura",
      lead: "Da Olbia a Santa Teresa, passando per Costa Smeralda e La Maddalena. Tocca un punto sulla mappa per scoprirlo.",
    },
    booking: {
      eyebrow: "Prenotazione",
      title: "Prenota la tua corsa",
      step1: "1. Servizio",
      step2: "2. Data & Dettagli",
      step3: "3. Pagamento",
      service_label: "Seleziona servizio",
      date_label: "Data del servizio",
      time_label: "Ora di pickup",
      pickup: "Indirizzo di partenza",
      dropoff: "Indirizzo di arrivo",
      passengers: "Passeggeri",
      luggage: "Bagagli",
      name: "Nome e cognome",
      email: "Email",
      phone: "Telefono",
      flight: "Numero volo (opzionale)",
      notes: "Note (opzionale)",
      total: "Prezzo del servizio",
      pay: "Conferma prenotazione",
      payment_note: "Pagamento in contanti o POS direttamente in auto",
      trust_payment: "Pagamento in auto",
      trust_ssl: "Sito sicuro · SSL",
      trust_gdpr: "GDPR compliant",
      trust_no_card: "Nessuna carta richiesta",
      back: "Indietro",
      next: "Avanti",
      success_title: "Richiesta inviata!",
      success_msg: "Riceverai una conferma su WhatsApp o telefono entro poche ore. Il pagamento avverrà direttamente in auto.",
      cancel_title: "Pagamento annullato",
      cancel_msg: "Non ti abbiamo addebitato nulla. Puoi riprovare quando vuoi.",
      processing: "Verifica pagamento in corso...",
      return_home: "Torna alla home",
      pick_date_first: "Seleziona prima una data",
      required: "Campo obbligatorio",
    },
    contact: {
      eyebrow: "Contatti",
      title: "Siamo a tua disposizione",
      lead: "Scrivici per qualsiasi richiesta. Ti rispondiamo in poche ore.",
      name: "Nome",
      email: "Email",
      phone: "Telefono",
      message: "Messaggio",
      send: "Invia messaggio",
      whatsapp: "Scrivici su WhatsApp",
      sent: "Messaggio inviato. Ti contatteremo presto.",
      qr_title: "Scansiona per aprire il sito",
      qr_hint: "Inquadra il QR con la fotocamera del tuo telefono e vieni portato direttamente su galluradrive.it",
    },
    footer: {
      tagline: "Servizio autista privato in Gallura.",
      rights: "Tutti i diritti riservati.",
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      territory: "Territory",
      booking: "Book",
      contact: "Contact",
      book_now: "Book Now",
    },
    hero: {
      eyebrow: "Private Chauffeur — Gallura, Sardinia",
      title: "Your private driver in Costa Smeralda",
      subtitle:
        "Luxury transfers and bespoke tours aboard our blue Chrysler 300C Touring. American elegance, Sardinian hospitality.",
      cta_primary: "Book your ride",
      cta_secondary: "Discover services",
      kpi_1: "Years of experience",
      kpi_2: "Gallura tours",
      kpi_3: "Onboard comfort",
    },
    car: {
      eyebrow: "The car",
      title: "Chrysler 300C Touring — Midnight Blue",
      desc: "An iconic American station wagon. Leather interiors, automatic climate, generous trunk for your suitcases and complimentary water on board.",
      f1: "Up to 4 passengers",
      f2: "Large luggage",
      f3: "On-board Wi-Fi",
      f4: "Complimentary water",
      gallery_title: "Gallery",
      gallery_hint: "Hover photos for description",
      more_photos_title: "Want to see more photos of the car?",
      more_photos_hint: "Message us on WhatsApp: we'll send them right away (interior, trunk, details)",
    },
    services: {
      eyebrow: "Services",
      title: "Tailored Transfers & Tours",
      lead: "Transparent pricing, pay on board (cash or card), suited-up driver.",
      from: "from",
      duration: "Duration",
      min: "min",
      book: "Book",
    },
    territory: {
      eyebrow: "The land",
      title: "Explore Gallura",
      lead: "From Olbia to Santa Teresa, passing through Costa Smeralda and La Maddalena. Tap a point on the map to discover it.",
    },
    booking: {
      eyebrow: "Booking",
      title: "Book your ride",
      step1: "1. Service",
      step2: "2. Date & Details",
      step3: "3. Payment",
      service_label: "Select service",
      date_label: "Service date",
      time_label: "Pickup time",
      pickup: "Pickup address",
      dropoff: "Drop-off address",
      passengers: "Passengers",
      luggage: "Luggage",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      flight: "Flight number (optional)",
      notes: "Notes (optional)",
      total: "Service price",
      pay: "Confirm booking",
      payment_note: "Cash or card payment directly in the car",
      trust_payment: "Pay in the car",
      trust_ssl: "Secure site · SSL",
      trust_gdpr: "GDPR compliant",
      trust_no_card: "No card required",
      back: "Back",
      next: "Next",
      success_title: "Booking confirmed!",
      success_msg: "You'll receive a confirmation email with all the details. Thank you for choosing us.",
      cancel_title: "Payment cancelled",
      cancel_msg: "You have not been charged. You can try again whenever you like.",
      processing: "Verifying payment...",
      return_home: "Back to home",
      pick_date_first: "Please pick a date first",
      required: "Required field",
    },
    contact: {
      eyebrow: "Contact",
      title: "We're here for you",
      lead: "Write us for any request. We'll reply within hours.",
      name: "Name",
      email: "Email",
      phone: "Phone",
      message: "Message",
      send: "Send message",
      whatsapp: "Chat on WhatsApp",
      sent: "Message sent. We'll be in touch soon.",
      qr_title: "Scan to open the site",
      qr_hint: "Point your phone's camera at the QR code and you'll go straight to galluradrive.it",
    },
    footer: {
      tagline: "Private chauffeur service in Gallura.",
      rights: "All rights reserved.",
    },
  },
};

const I18nContext = createContext({ lang: "it", setLang: () => {}, t: dict.it });

const readLangFromUrl = () => {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  const q = params.get("lang");
  return q === "en" || q === "it" ? q : null;
};

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    // Priority: URL query > localStorage > default IT
    return readLangFromUrl() || localStorage.getItem("ncc_lang") || "it";
  });
  useEffect(() => {
    localStorage.setItem("ncc_lang", lang);
    // Reflect language change in <html lang> for accessibility & SEO
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  // React to browser back/forward navigation that may change ?lang=
  useEffect(() => {
    const onPop = () => {
      const urlLang = readLangFromUrl();
      if (urlLang && urlLang !== lang) setLang(urlLang);
    };
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, [lang]);

  const value = { lang, setLang, t: dict[lang] };
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
